/** Green New/Updated callout tags (navbar). */
export const CALLOUT_BADGE_PROPS = {
  colorScheme: 'green',
  fontSize: '2xs',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  h: '1.5em',
  px: 1.5,
  py: 0,
  borderRadius: 'sm',
  lineHeight: '1',
  textTransform: 'none',
  fontWeight: 'semibold',
} as const;
